module.exports = __webpack_public_path__ + "static/media/logo_salvador.e3d3a4cb.png";